// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const KeyIcon = /* @__PURE__ */ createIcon(
  'key',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M20 9a5 5 0 1 0-9.955.674c.028.209.053.394.068.543.013.139.026.327-.002.52a1.8 1.8 0 0 1-.233.693c-.153.273-.403.51-.592.698l-5.11 5.11c-.093.093-.139.14-.171.175l-.003.003v.003C4 17.466 4 17.532 4 17.663V19.4c0 .297.001.46.01.576l.002.011.013.002c.116.01.278.011.575.011H6v-1a1 1 0 0 1 1-1h1v-1a1 1 0 0 1 1-1h1.586l1.286-1.286c.189-.189.425-.44.698-.592l.17-.086c.165-.075.324-.119.523-.147l.143-.014a3 3 0 0 1 .377.013c.15.014.334.039.543.067q.33.045.674.045a5 5 0 0 0 5-5m-4 0a1 1 0 0 0-.293-.707A1 1 0 0 0 15 8a1 1 0 1 1 0-2c.766 0 1.536.293 2.121.879.586.585.88 1.355.88 2.121a1 1 0 0 1-2 0m6 0a7 7 0 0 1-7.94 6.938c-.225-.03-.366-.05-.469-.06l-.045-.004-.01.01a8 8 0 0 0-.25.244l-1.579 1.579A1 1 0 0 1 11 18h-1v1a1 1 0 0 1-1 1H8v1a1 1 0 0 1-1 1H4.6c-.264 0-.522.001-.739-.017a2 2 0 0 1-.769-.2 2 2 0 0 1-.874-.875 2 2 0 0 1-.201-.77C1.999 19.923 2 19.665 2 19.4v-1.737c0-.197-.006-.459.056-.716a2 2 0 0 1 .24-.578c.137-.225.327-.405.466-.545l5.11-5.11c.126-.126.196-.197.244-.25l.01-.01-.004-.045c-.01-.102-.03-.244-.06-.469A7 7 0 1 1 22 9',
      },
    ],
  ]
);
